export const diagnosesFrag = `
    ageFrom
    ageTo
    code
    name
    parentName
    selectable
    sex
    sign
    bonifications {
        expertise
        validFrom
        validTo
    }
`;
